/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleLevelTitle } from './moduleLevelTitle';
import type { ModuleLevelObjectives } from './moduleLevelObjectives';

/**
 * Level of a modul with its optional title
 */
export interface ModuleLevel {
  id: number;
  title?: ModuleLevelTitle;
  objectives?: ModuleLevelObjectives;
}
